import type { Product } from '../types';

export const STORE_CURRENCY = 'TRY' as const;

export function formatPrice(product: Product): string {
  if (product.priceLabel) return product.priceLabel;
  const price = product.effectivePrice ?? product.price;
  if (product.currency === 'EUR') return `${price.toLocaleString('tr-TR')} €`;
  return `${price.toLocaleString('tr-TR')} ₺`;
}

export function hasEffectiveDiscount(product: Product): boolean {
  return product.effectivePrice != null && product.effectivePrice < product.price;
}

export function formatAmount(amount: number, currency: 'EUR' | 'TRY' = STORE_CURRENCY): string {
  if (currency === 'EUR') return `${amount.toLocaleString('tr-TR')} €`;
  return `${amount.toLocaleString('tr-TR')} ₺`;
}
